module.exports = {"140971100":"台怀镇","140971101":"石咀镇","140971200":"金岗库乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140971.json
// module id = 447
// module chunks = 0